import { Component, Input } from '@angular/core';
import { resolveStatusBadgeType, StatusBadgeType } from './status-badge-code';

export type { StatusBadgeType } from './status-badge-code';
export { StatusBadgeCode } from './status-badge-code';

@Component({
  selector: 'app-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss'],
  standalone: false,
})
export class StatusBadgeComponent {
  @Input() type: StatusBadgeType | number = 'default';
  @Input() label = '';

  get resolvedType(): StatusBadgeType {
    return resolveStatusBadgeType(this.type);
  }
}
